<div class="container">
  <div class="row card">
    <div class="card-body col-md-6">
      <h2 class="title">Tools</h2>
      <button
        class="btn btn-primary my-2 text-white text-uppercase"
        (click)="openScrollableContent(transcript)">
        View video transcript
      </button>
    </div>
  </div>
</div>

<ng-template #transcript let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Video Transcript - How to Get Started</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body fs-6" style="height: 35vh">
    <p>
      Wow! You’ve put together a great life list, but what we want to do now is
      just take a piece of that. It’s kind of like eating a cake. You're not
      going to eat the whole thing in one sitting. So, today we're going to just
      choose five of the most exciting events that you cannot wait to write
      about, and that's what we're going to do next.
    </p>
    <p>
      When you're picking your five stories, think about what photographs you
      have, because that adds a lot of value to the reader. Plus, it'll help you
      in making the writing process a lot easier when you have a reference, a
      visual reference, to work with.
    </p>
    <p>
      One more thing to consider is who is your audience. Why are you writing
      this? Are you writing it for your grandchildren? Are you writing it for
      yourself, because you want to recap your life? But, you have to consider
      who is going to be reading this.
    </p>
    <p>
      One more thing to think about whenever you're creating your story is don't
      make it too broad. You want to focus. You don't want to write about what
      happened in the 1990s. That's a volume in itself. What you want to talk
      about is the first day you attended college or the first day that you met
      someone, so make it focused on a specific event rather than a broad topic.
    </p>
    <p>
      When you're ready, click the box next to the sentence of your five
      favorite topics. Then click Continue to Step 3. Remember that you must
      have exactly five sentences selected to move forward. Have fun with that,
      and I'll see you in the next video!
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')">
      Close
    </button>
  </div>
</ng-template>
